import type { ScopedConnectionItem } from '@/workspace/connection-api';

// One tool card, with access chosen for that connection. Never synthesize a
// grant or infer permission from a provider name or the member's role.
export function connectionOptions(items: readonly ScopedConnectionItem[]) {
  const providers = [...new Set(items.map((item) => item.id))];
  return providers.map((id) => {
    const options = items.filter((item) => item.id === id);
    const primary =
      options.find((item) => item.status === 'connected') ??
      options.find((item) => item.audience === 'private' && item.actions.connect.available) ??
      options.find((item) => item.actions.connect.available) ??
      options.find((item) => item.audience === 'private') ??
      options[0];
    return { primary, options };
  });
}
